import { useEffect, useRef } from 'react';
import { withSearch } from '@elastic/react-search-ui';

function FilterValidator({ facets, filters, results, removeFilter }) {
  const prevFacetsRef = useRef();
  const isValidatingRef = useRef(false);

  useEffect(() => {
    if (
      !facets ||
      !filters ||
      filters.length === 0 ||
      isValidatingRef.current
    ) {
      return;
    }

    const facetsJson = JSON.stringify(facets);

    if (prevFacetsRef.current === facetsJson) {
      return;
    }

    prevFacetsRef.current = facetsJson;
    isValidatingRef.current = true;

    filters.forEach(filter => {
      if (Object.prototype.hasOwnProperty.call(facets, filter.field)) {
        const facetData = facets[filter.field]?.[0]?.data || [];
        const validValues = facetData.map(option => option.value);

        filter.values.forEach(value => {
          if (!validValues.includes(value)) {
            removeFilter(filter.field, value);
          }
        });
      }
    });

    isValidatingRef.current = false;
  }, [facets, filters, results, removeFilter]);

  return null;
}

export default withSearch(({ facets, filters, results, removeFilter }) => ({
  facets,
  filters,
  results,
  removeFilter,
}))(FilterValidator);
